module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=RE - Reunion.f3b5c358.svg";